export const ROOT_ID = 'wptelegram-widget-settings';
